//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ButtonAction from '@/shared/components/ButtonAction.vue';
import StackedSection from '~/components/StackedSection.vue';
import JournalSurvey from './Journal_Survey.vue';

export default {
  name: 'Journal_CTA',
  components: {
    StackedSection,
    ButtonAction,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  methods: {
    openModal() {
      if (this.modalShowing === true) {
        return;
      }
      this.exitIntent = true;
      this.modalShowing = true;
      this.seen = true;
      this.$modal.show(JournalSurvey, {}, {
        adaptive: true,
        width: '95%',
        maxWidth: 800,
        height: 'auto',
        scrollable: true,
      }, {
        'before-close': () => {
          this.$store.commit('SET_SHOW_EMAIL_INPUT', true);
          this.modalShowing = false;
        },
      });
    },
  },
};
